export const SITE_URL = 'https://jiaolukeji.cn';

export const SITE = {
  name: '吃瓜观察局',
  slogan: '围观热搜话题，看清舆论风向',
  url: SITE_URL,
  email: 'hi@chiguaguancha.online',
  contactEmail: 'hezuo@chiguaguancha.online',
  since: '2021',
  intro:
    '吃瓜观察局是一个聚焦网络热点话题的观察型内容站点，我们不生产情绪，只梳理脉络。用时间线还原事件发酵过程，用观点分布呈现各方立场，用评论区实录呈现真实的讨论现场。',
  subscribeFormAddr: 'https://readdy.ai/api/form/dahro8boh653ivfvo48g',
  contactFormAddr: 'https://readdy.ai/api/form/dahro8boh653ivfvo490',
};

export interface NavItem {
  label: string;
  to: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: '首页', to: '/' },
  { label: '话题广场', to: '/topics' },
  { label: '关于我们', to: '/about' },
];

export interface CategoryItem {
  name: string;
  slug: string;
  icon: string;
  desc: string;
}

export const CATEGORIES: CategoryItem[] = [
  { name: '娱乐八卦', slug: 'entertainment', icon: 'ri-fire-line', desc: '艺人动态、活动风波与话题热度追踪' },
  { name: '影视综艺', slug: 'screen', icon: 'ri-movie-line', desc: '剧集、综艺的剪辑、改编与口碑讨论' },
  { name: '网络消费', slug: 'consumer', icon: 'ri-shopping-bag-3-line', desc: '直播带货、平台规则与消费体验争议' },
  { name: '科技数码', slug: 'tech', icon: 'ri-cpu-line', desc: 'AI、平台算法与新技术带来的争议话题' },
  { name: '体育赛事', slug: 'sports', icon: 'ri-basketball-line', desc: '赛事规则、名额分配与观赛体验讨论' },
  { name: '社会观察', slug: 'society', icon: 'ri-earth-line', desc: '公共议题、社区文化与表达边界的思考' },
];